import bugsnagclient from './bugsnag.native';
import Bugsnag from '@bugsnag/expo';
export const logException = (error, opts = {}) => {
  const errorToSend = typeof error === 'string' ? new Error(error) : error;
  Bugsnag.notify(errorToSend, opts);
};
